var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.262365 8.32346C0.145211 8.44061 0.145211 8.63055 0.262365 8.74771L1.25233 9.73767C1.36948 9.85483 1.55942 9.85483 1.67658 9.73767L4.99999 6.41426L8.3234 9.73767C8.44055 9.85483 8.63049 9.85483 8.74765 9.73767L9.73761 8.74771C9.85477 8.63055 9.85477 8.44061 9.73761 8.32346L6.4142 5.00005L9.73761 1.67664C9.85477 1.55949 9.85477 1.36955 9.73761 1.25239L8.74765 0.262426C8.63049 0.145272 8.44055 0.145272 8.3234 0.262426L4.99999 3.58584L1.67658 0.262426C1.55942 0.145272 1.36948 0.145272 1.25233 0.262426L0.262365 1.25239C0.145211 1.36955 0.145211 1.55949 0.262365 1.67664L3.58577 5.00005L0.262365 8.32346Z",
    fill: "#007FAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e05777539e87f17e00a92e73962e0984.svg";
export { ForwardRef as ReactComponent };